/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CheckInBoardingPassByEmailRequest } from '../../models/check-in-boarding-pass-by-email-request';
import { CheckInBoardingPassByEmailResponse } from '../../models/check-in-boarding-pass-by-email-response';

export interface SendBoardingPass$Params {
  orderId: string;
  hash?: string;
      body: CheckInBoardingPassByEmailRequest
}

export function sendBoardingPass(http: HttpClient, rootUrl: string, params: SendBoardingPass$Params, context?: HttpContext): Observable<DapiHttpResponse<CheckInBoardingPassByEmailResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, sendBoardingPass.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<CheckInBoardingPassByEmailResponse>;
    }),
    catchErrorAsJson()
  );
}

sendBoardingPass.PATH = '/api/v2/checkin/{orderId}/send-boarding-pass';
